import React, { useState, useRef } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { toast } from 'sonner';

const QuotationModal = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);
  const iframeRef = useRef(null);

  const GOOGLE_FORM_ACTION_URL = "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfmYNnPLM0sTRSxnJkTRcE390T77D8zU0jYou4_bGB5DE_wLw/formResponse";

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    if (formRef.current) {
        formRef.current.submit();
    }

    setTimeout(() => {
        setIsSubmitting(false);
        toast.success("Quotation request submitted! We will contact you soon.");
        if (formRef.current) formRef.current.reset();
        setOpen(false);
    }, 1500); 
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-blue-900">Request a Quotation</DialogTitle>
          <DialogDescription>
            Fill out the form below and we'll get back to you with a detailed proposal.
          </DialogDescription>
        </DialogHeader>
        
        {/* Hidden Iframe for silent submission */}
        <iframe 
            name="hidden_iframe_quote" 
            id="hidden_iframe_quote" 
            style={{ display: 'none' }} 
            ref={iframeRef}
            title="submission-frame-quote"
        ></iframe>

        <form 
            ref={formRef}
            action={GOOGLE_FORM_ACTION_URL}
            method="POST"
            target="hidden_iframe_quote"
            onSubmit={handleSubmit} 
            className="space-y-4 mt-4"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="entry.1033193398">Name</Label>
              <Input
                name="entry.1033193398"
                id="entry.1033193398"
                required
                placeholder="Your name"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="entry.1216225020">Phone</Label>
              <Input
                name="entry.1216225020"
                id="entry.1216225020"
                required
                type="tel"
                placeholder="+91..."
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="entry.694199460">Email</Label>
            <Input
              name="entry.694199460"
              id="entry.694199460"
              required
              type="email"
              placeholder="your@email.com"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="entry.985243011">Company Name (Optional)</Label>
            <Input
              name="entry.985243011"
              id="entry.985243011"
              placeholder="Your company"
            />
          </div>


          {/* Re-implementing Service Selection using standard select for reliability with Google Form raw submission */}
           <div className="space-y-2">
            <Label htmlFor="entry.907241413">Service Required</Label>
            <select
              name="entry.907241413"
              id="entry.907241413"
              required
              className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            >
                <option value="" disabled selected>Select a service</option>
                <option value="Custom Software Development">Custom Software Development</option>
                <option value="Web Development">Web Development</option>
                <option value="Mobile App Development">Mobile App Development</option>
                <option value="Cloud & IT Services">Cloud & IT Services</option>
                <option value="IT Support & AMC">IT Support & AMC</option>
                <option value="Digital Marketing">Digital Marketing</option>
            </select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="entry.1226170176">Project Description</Label>
            <Textarea
              name="entry.1226170176"
              id="entry.1226170176"
              required
              placeholder="Brief description of your requirements..."
              rows={4}
            />
          </div>

          <div className="pt-4">
            <Button 
              type="submit" 
              className="w-full bg-gradient-to-r from-blue-700 to-indigo-900 hover:from-blue-800 hover:to-indigo-950 text-white"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Request'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuotationModal;
